import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = () => ({
  video: {
    width: "640px",
    height: "360px"
  }
});

const Video = ({ classes, className, src, name }) => {
  if (typeof window !== "undefined") {
    return (
      <div id={name}>
        <iframe
          className={`${classes.video} ${className}`}
          src={src}
          frameBorder="0"
          allowFullScreen
        />
      </div>
    );
  } else {
    return <div />
  }
};

Video.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  name: PropTypes.string
};

export default injectSheet(styles)(Video);



// WEBPACK FOOTER //
// ./src/components/Video.jsx